// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Toastr, Button } from "@revvsales/components";

// Components Imports
import { ReactSelect } from "../../../commonComponents";
import WFConditionsList from "../WFConditionsList";

// Actions Imports
import { WorkFlowActions } from "../../../actions";

// Internals Imports
import { WORKFLOW } from "../../../constants";

// Destructuring
const { updateWorkFlowData, nukeFormFiledData } = WorkFlowActions;
const { OPERATORS_REVERSE_MAPPING } = WORKFLOW;

// Declarations
const CONDITION_OBJECT = {
  param: "",
  rel_op: "",
  value: "",
};
const PRICEBOOK_TITLE = "Pricebook Level";
const PRODUCT_TITLE = "SKU Level";

class WFConditions extends Component {
  _updateState = newState => {
    this.props.updateWorkFlowData("condition", newState, this.props.index);
  };

  _onAddCondition = type => {
    const cloneState = Object.assign({}, this.props.data);
    let isNotEmpty = true;

    // CHECK IF THE LAST CONDITION VALUES IS NOT EMPTY
    if (cloneState.conditions.length > 0) {
      const lastRowIndex = cloneState.conditions.length - 1;
      isNotEmpty = Object.values(cloneState.conditions[lastRowIndex]).every(
        value => value !== "",
      );
    }

    // ACTIONS BASED ON ABOVE CONDITION
    if (isNotEmpty) {
      cloneState.conditions.push({ ...CONDITION_OBJECT });
      cloneState.type = type;
      this._updateState(cloneState);
    } else {
      Toastr.showToastr({
        type: "warning",
        message: "Please fill in the required fields.",
        timeout: 3000,
      });
    }
  };

  _onRemoveCondition = index => {
    const cloneState = Object.assign({}, this.props.data);
    cloneState.conditions.splice(index, 1);
    this._updateState(cloneState);
  };

  _onRemoveRule = () => {
    this.props.nukeFormFiledData();
  };

  _onInputChange = (field, event, index, isNumField) => {
    const value = String(isNumField ? event : event.target.value);
    if (index !== undefined) {
      const cloneState = Object.assign({}, this.props.data);
      cloneState.conditions[index][field] = value;
      this._updateState(cloneState);
    } else {
      this._updateState({ [field]: value });
    }
  };

  _onSelectChange = (field, value, index) => {
    if (index !== undefined) {
      const cloneState = Object.assign({}, this.props.data);
      if (field === "rel_op") {
        cloneState.conditions[index][field] =
          OPERATORS_REVERSE_MAPPING[value.label];
      } else {
        cloneState.conditions[index][field] = value.label;
      }
      // Reset Operator Options based on Param filed selection
      if (field === "param") {
        cloneState.conditions[index].rel_op = "";
        cloneState.conditions[index].value = "";
      }
      this._updateState(cloneState);
    } else {
      this._updateState({ [field]: value });
    }
  };

  _toggleLogicalOperatorVisibility = () => {
    const cloneState = Object.assign({}, this.props.data);
    cloneState.showOperators = !cloneState.showOperators;
    this._updateState(cloneState);
  };

  render() {
    const { products, pricelist, data, attributes } = this.props;
    const { conditions, priceBook, product, type } = data;
    return (
      <div className="wfconditions-wrapper">
        {/* COMMON TITLE SECTION FOR THE FLOW */}
        <div className="wfconditions-title-section">
          <div className="wfconditions-icon">
            <FontAwesomeIcon icon={["fas", "tasks"]} />
          </div>
          <div className="wfconditions-info">
            <div className="wfconditions-title">Conditions</div>
            <div className="wfconditions-subtitle">
              Select conditions which will trigger this workflow
            </div>
          </div>
        </div>

        {/* EMPTY SECTION WHEN NO CONDITION IS SET */}
        {!conditions.length > 0 && (
          <Fragment>
            {/* SECTION TO DISPLAY EMPTY MESSAGE */}
            <div className="wfconditions-empty-section">
              <div className="wfconditions-empty-info">
                Your workflow does not have a trigger condition yet. Select a
                condition trigger from the suggested triggers.
              </div>
            </div>

            {/* SECTION TO SET CONDITIONS FOR PRICEBOOK OR SKU LEVEL */}
            <div className="wfconditions-approval-section">
              <div className="wfconditions-section-title">
                Suggested Triggers
              </div>
              <div
                className="wfconditions-approval-wrapper"
                onClick={() => this._onAddCondition("DEAL_PRICEBOOK")}
                onKeyPress={() => this._onAddCondition("DEAL_PRICEBOOK")}
                role="button"
                tabIndex="0">
                <div className="wfconditions-approval-title">
                  <span className="wfconditions-expand-ico">
                    <FontAwesomeIcon icon={["far", "plus"]} />
                  </span>
                  <span>{PRICEBOOK_TITLE}</span>
                </div>
              </div>
              <div
                className="wfconditions-approval-wrapper"
                onClick={() => this._onAddCondition("DEAL_SKU")}
                onKeyPress={() => this._onAddCondition("DEAL_SKU")}
                role="button"
                tabIndex="0">
                <div className="wfconditions-approval-title">
                  <span className="wfconditions-expand-ico">
                    <FontAwesomeIcon icon={["far", "plus"]} />
                  </span>
                  <span>{PRODUCT_TITLE}</span>
                </div>
              </div>
            </div>
          </Fragment>
        )}

        {/* WHEN A CONDITION IS SELECTED */}
        {conditions.length > 0 && (
          <div className="wfconditions-trigger-section">
            <div className="wfconditions-trigger-title">
              <span className="wfconditions-tick-ico">
                <FontAwesomeIcon icon={["far", "check"]} />
              </span>
              <div className="wfconditions-title-txt">
                {type === "DEAL_SKU" ? PRODUCT_TITLE : PRICEBOOK_TITLE}
              </div>
              <span
                className="wfconditions-delete-ico"
                onClick={this._onRemoveRule}
                onKeyPress={this._onRemoveRule}
                role="button"
                tabIndex="0">
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </span>
            </div>
            {/* CONDITION BODY SECTION */}
            <div className="wfconditions-trigger-body">
              <div className="wfconditions-selection-wrapper">
                {/* WHEN A PRODUCT OPTION IS SELECTED */}
                {type === "DEAL_SKU" && (
                  <div className="wfconditions-div-wrapper">
                    <span className="revvform-label">Select Product</span>
                    <ReactSelect
                      isSearchable
                      valueKey="name"
                      options={products}
                      value={product}
                      onChange={value => this._onSelectChange("product", value)}
                      data-test="wfconditions-select-product-select"
                    />
                  </div>
                )}
                <div className="wfconditions-div-wrapper">
                  <span className="revvform-label">
                    Select an applicable Price Book
                  </span>
                  <ReactSelect
                    isSearchable
                    valueKey="name"
                    options={pricelist}
                    value={priceBook}
                    onChange={value => this._onSelectChange("priceBook", value)}
                    data-test="wfconditions-select-pricebook-select"
                  />
                </div>
              </div>
              {/* CONDITION LIST SECTION */}
              {conditions.map((item, index) => (
                <WFConditionsList
                  key={item.id}
                  // Data passed to component
                  data={data} // FormFiled Redux data
                  attributes={attributes} // Attributes Value from redux
                  condition={item} // Condition data of a loop
                  index={index} // Loop index
                  // Functions passed to component
                  onInputChange={this._onInputChange}
                  onRemoveCondition={this._onRemoveCondition}
                  onSelectChange={this._onSelectChange}
                  toggleLogicalOperatorVisibility={
                    this._toggleLogicalOperatorVisibility
                  }
                />
              ))}
            </div>
            <div className="wfconditions-add-wrapper">
              <Button
                className="revv-btn-secondary-sm"
                onClick={() => this._onAddCondition(type)}
                onKeyPress={() => this._onAddCondition(type)}
                role="button"
                tabIndex="0"
                data-test="wfconditions-add-condition-btn">
                <FontAwesomeIcon icon={["far", "plus"]} /> Add another Condition
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    attributes,
    metaData,
    pricelist,
    products,
    workflowDetails: { rule = {} },
  } = state.WorkFlowStore;
  return {
    attributes,
    metaData,
    pricelist,
    products,
    rule,
  };
};

const mapDispatchToProps = {
  updateWorkFlowData,
  nukeFormFiledData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WFConditions);



// WEBPACK FOOTER //
// ./src/components/WorkFlow/WFConditions/WFConditions.js